<template>
  <div class="info-board order-detail-stats f-r">
    <div class="left">
      <div class="col">
        <div
          class="stats-info-card blue-business-bg"
          v-for="status in Object.keys(palletCounts)"
          :key="status"
        >
          <div class="info-card-left">
            <span class="title">{{ palletCounts[status] }} Pallets</span>
            <span class="sub-title">{{ status }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="title">Shipping Records</div>
      <div class="record-rows" v-if="shippingRecords.length > 0">
        <div
          v-for="(record, idx) in shippingRecords"
          :key="idx"
          class="record-row"
        >
          <span class="bold-oswald pallet-cnt">
            {{ record.cnt }}
          </span>
          pallet{{ record.cnt > 1 ? 's' : '' }} in
          <el-link
            type="primary"
            @click="goToShipmentDetail(record.no)"
            class="title"
          >
            {{ record.no }} </el-link
          >, the status is
          <el-tag size="small">
            {{ record.status }}
          </el-tag>
        </div>
      </div>
      <span v-else>No shipping records</span>
    </div>
  </div>
</template>
<script>
// models
import {
  PalletDelivered,
  PalletOffStack,
  PalletOnStack,
  PalletOnStage,
  PalletShipping,
  PalletUpcoming
} from '@/core/models/pallet'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// api
import { queryPallets, searchStock } from '@/api/pallet'
export default {
  name: 'OrderStats',
  mixins: [pageJumps],
  props: {
    orderId: {
      type: String,
      required: true
    },
    riiOrderNo: {
      type: String
    }
  },
  data() {
    return {
      PalletDelivered,
      PalletOffStack,
      PalletOnStack,
      PalletShipping,
      PalletUpcoming,
      palletCounts: {
        [PalletUpcoming]: 999,
        [PalletOnStack]: 999,
        [PalletOffStack]: 999,
        [PalletOnStage]: 999,
        [PalletDelivered]: 999,
        [PalletShipping]: 999
      },
      shippingRecords: []
    }
  },
  watch: {
    orderId: {
      handler(value) {
        if (value) {
          this.countAllPallets()
          this.findPalletsInShip()
        }
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    getCardStyle(status) {
      switch (status) {
        case PalletUpcoming:
          return 'deep-yellow-bg'
        case PalletOnStack:
          return 'blue-business-bg'
        case PalletOffStack:
          return 'hash-brown-bg'
        case PalletOnStage:
          return 'blue-business-bg'
        case PalletDelivered:
          return 'deep-green-bg'
        case PalletShipping:
          return 'deep-green-bg'
      }
    },
    countAllPallets() {
      Object.keys(this.palletCounts).forEach(status => {
        this.countPallets(status)
      })
    },
    countPallets(status) {
      queryPallets({
        statusList: [status],
        size: 1000,
        current: 1,
        orderIds: [this.orderId]
      }).then(res => {
        this.palletCounts[status] = res.total
      })
    },
    findPalletsInShip() {
      if (!this.riiOrderNo) return
      searchStock({
        riiOrderNos: [this.riiOrderNo],
        onlyShipped: true,
        size: -1
      }).then(res => {
        if (res) {
          this.$set(
            this,
            'shippingRecords',
            res.records.map(one => ({
              cnt: one.palletIds.split(',').length,
              no: one.shipmentNo,
              status: one.status
            }))
          )
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  min-width: 900px;
  gap: 10px;

  .right {
    flex-grow: 1;
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    overflow-y: scroll;

    .title {
      font-size: $title-level-two;
      font-weight: bolder;
    }

    .record-rows {
      margin-top: 10px;

      @extend .f-c;

      gap: 5px;
    }

    @extend .shadow-level-three;
  }

  .left {
    .col {
      gap: 20px;
      width: 560px;
      flex-wrap: wrap;

      .stats-info-card {
        pointer-events: none;
        min-width: 130px !important;
        padding: 22px 20px;

        .info-card-left {
          .title {
            font-size: 24px;
            font-family: 'oswald bold', sans-serif;
          }

          .sub-title {
            margin-top: 5px;
            font-size: 24px;
            font-family: 'oswald bold', sans-serif;
          }
        }
      }

      @extend .f-r;
    }
  }
}
</style>
